import { SvgIcon, SvgIconProps } from "@mui/material";

export const ThumbsDownIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M6.944 5H5.056C4.473 5 4 5.473 4 6.056v7.388c0 .583.473 1.056 1.056 1.056h1.888C7.527 14.5 8 14.027 8 13.444V6.056C8 5.473 7.527 5 6.944 5"
        clip-rule="evenodd"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="m8 13.428 3.649 4.75a1.734 1.734 0 0 0 2.714.047v0c.265-.321.409-.725.409-1.141v-3.271h3.096a1.8 1.8 0 0 0 1.496-.8l.329-.49a1.8 1.8 0 0 0 .234-1.5l-1.359-4.721A1.8 1.8 0 0 0 16.839 5H10.55a1.8 1.8 0 0 0-1.318.574L8 6.9"
      />
    </svg>
  </SvgIcon>
);
